import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Card, CardBody } from '@vnetwork/ui/primitives';
import { WorkdayTab } from './components/tabs/WorkdayTab';
import { AccountBreadcrumbs } from './components/account-breadcrumbs';

/** Workday Accounts — the current employee's monthly attendance calendar. */
export default function WorkdaysPage() {
  return (
    <Container size="full">
      <PageHeader breadcrumbs={<AccountBreadcrumbs current="Workdays" />} title="Workday Accounts" description="Your monthly attendance and worked hours" />
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <Card flat>
          <CardBody>
            <WorkdayTab />
          </CardBody>
        </Card>
      </div>
    </Container>
  );
}
